import { render } from "./RoleConsents.vue?vue&type=template&id=40ab7eaa&ts=true"
import script from "./RoleConsents.vue?vue&type=script&lang=ts"
export * from "./RoleConsents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Roles/RoleConsents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40ab7eaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40ab7eaa', __exports__)) {
    api.reload('40ab7eaa', __exports__)
  }
  
  module.hot.accept("./RoleConsents.vue?vue&type=template&id=40ab7eaa&ts=true", () => {
    api.rerender('40ab7eaa', render)
  })

}


export default __exports__